var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vx-row" }, [
    _c(
      "div",
      { staticClass: "vx-col lg:w-3/5 w-full" },
      [
        _c("vx-card", { staticClass: "mb-4" }, [
          _c("h4", { staticClass: "mb-1" }, [
            _vm._v(_vm._s(_vm.$t("cancellation.policy_data"))),
          ]),
          _c("small", { staticClass: "text-muted d-block mb-3" }, [
            _vm._v(_vm._s(_vm.$t("cancellation.policy_data_hint"))),
          ]),
          _c("div", { staticClass: "vx-row" }, [
            _c(
              "div",
              { staticClass: "vx-col sm:w-1/2 w-full" },
              [
                _c(
                  "b-form-group",
                  {
                    attrs: {
                      label: _vm.$t("cancellation.policy_name"),
                      "label-for": "name",
                    },
                  },
                  [
                    _c("b-form-input", {
                      staticClass: "required",
                      attrs: { id: "name", type: "text" },
                      model: {
                        value: _vm.model.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "name", $$v)
                        },
                        expression: "model.name",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "vx-col sm:w-1/2 w-full" },
              [
                _c(
                  "b-form-group",
                  {
                    attrs: {
                      label: _vm.$t("cancellation.establishments"),
                      "label-for": "legal_entities",
                    },
                  },
                  [
                    _c(
                      "v-select",
                      {
                        staticClass: "w-full required-select",
                        attrs: {
                          id: "legal_entities",
                          options: _vm.legalEntityOptions,
                          reduce: function (opt) {
                            return opt.id
                          },
                          label: "name",
                          placeholder: _vm.$t(
                            "cancellation.establishments_placeholder"
                          ),
                          multiple: "",
                        },
                        model: {
                          value: _vm.selectedLegalEntityIds,
                          callback: function ($$v) {
                            _vm.selectedLegalEntityIds = $$v
                          },
                          expression: "selectedLegalEntityIds",
                        },
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "no-options" }, slot: "no-options" },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("cancellation.no_establishments"))
                            ),
                          ]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "vx-row" }, [
            _c(
              "div",
              { staticClass: "vx-col w-full" },
              [
                _c(
                  "b-form-group",
                  {
                    attrs: {
                      label: _vm.$t("cancellation.applied_to"),
                      "label-for": "applies_to",
                    },
                  },
                  [
                    _c(
                      "v-select",
                      {
                        staticClass: "w-full",
                        attrs: {
                          id: "applies_to",
                          options: _vm.productOptions,
                          disabled: _vm.model.is_default,
                          placeholder: _vm.model.is_default
                            ? _vm.$t("cancellation.applies_all")
                            : _vm.$t("cancellation.applies_placeholder"),
                          multiple: "",
                          taggable: "",
                          "push-tags": "",
                        },
                        model: {
                          value: _vm.appliesToItems,
                          callback: function ($$v) {
                            _vm.appliesToItems = $$v
                          },
                          expression: "appliesToItems",
                        },
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "no-options" }, slot: "no-options" },
                          [_vm._v(_vm._s(_vm.$t("cancellation.no_products")))]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            {
              staticClass: "flex justify-between items-center border-top pt-3",
            },
            [
              _c("div", [
                _c("div", [_vm._v(_vm._s(_vm.$t("cancellation.is_default")))]),
                _c("small", { staticClass: "text-muted" }, [
                  _vm._v(_vm._s(_vm.$t("cancellation.is_default_hint"))),
                ]),
              ]),
              _c("b-form-checkbox", {
                attrs: { switch: "" },
                model: {
                  value: _vm.model.is_default,
                  callback: function ($$v) {
                    _vm.$set(_vm.model, "is_default", $$v)
                  },
                  expression: "model.is_default",
                },
              }),
            ],
            1
          ),
        ]),
        _c(
          "vx-card",
          { staticClass: "mb-4" },
          [
            _c(
              "div",
              { staticClass: "flex justify-between items-center mb-4" },
              [
                _c("h4", { staticClass: "mb-0" }, [
                  _vm._v(_vm._s(_vm.$t("cancellation.tiers"))),
                ]),
                _c(
                  "b-button",
                  {
                    attrs: { variant: "flat-primary", size: "sm" },
                    on: { click: _vm.addTier },
                  },
                  [
                    _c("feather-icon", {
                      staticClass: "mr-50",
                      attrs: { icon: "PlusIcon" },
                    }),
                    _c("span", { staticClass: "align-middle" }, [
                      _vm._v(_vm._s(_vm.$t("cancellation.add_tier"))),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._l(_vm.version.tiers, function (tier, i) {
              return _c(
                "div",
                { key: i, staticClass: "tier-row border rounded p-1 mb-1" },
                [
                  _c("div", { staticClass: "vx-row items-end" }, [
                    _c(
                      "div",
                      { staticClass: "vx-col sm:w-2/12 w-full" },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: _vm.$t("cancellation.antecedence"),
                              "label-size": "sm",
                            },
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                type: "number",
                                min: "0",
                                size: "sm",
                                placeholder: "De (h)",
                              },
                              model: {
                                value: tier.min_hours,
                                callback: function ($$v) {
                                  _vm.$set(tier, "min_hours", _vm._n($$v))
                                },
                                expression: "tier.min_hours",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "vx-col sm:w-2/12 w-full" },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Até (h)", "label-size": "sm" } },
                          [
                            _c("b-form-input", {
                              attrs: {
                                type: "number",
                                min: "0",
                                size: "sm",
                                placeholder: "Sem limite",
                              },
                              model: {
                                value: tier.max_hours,
                                callback: function ($$v) {
                                  _vm.$set(tier, "max_hours", _vm._n($$v))
                                },
                                expression: "tier.max_hours",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "vx-col sm:w-3/12 w-full" },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: _vm.$t("cancellation.remedy"),
                              "label-size": "sm",
                            },
                          },
                          [
                            _c("b-form-select", {
                              attrs: { options: _vm.remedyOptions, size: "sm" },
                              model: {
                                value: tier.remedy,
                                callback: function ($$v) {
                                  _vm.$set(tier, "remedy", $$v)
                                },
                                expression: "tier.remedy",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "vx-col sm:w-2/12 w-full" },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: _vm.$t("cancellation.fixed_fee"),
                              "label-size": "sm",
                            },
                          },
                          [
                            _c(
                              "b-input-group",
                              { attrs: { prepend: "R$", size: "sm" } },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    type: "number",
                                    min: "0",
                                    step: "0.01",
                                    size: "sm",
                                  },
                                  model: {
                                    value: tier.fixed_fee,
                                    callback: function ($$v) {
                                      _vm.$set(tier, "fixed_fee", _vm._n($$v))
                                    },
                                    expression: "tier.fixed_fee",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "vx-col sm:w-2/12 w-full" },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: _vm.$t("cancellation.penalty"),
                              "label-size": "sm",
                            },
                          },
                          [
                            _c(
                              "b-input-group",
                              { attrs: { append: "%", size: "sm" } },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    type: "number",
                                    min: "0",
                                    max: "100",
                                    size: "sm",
                                  },
                                  model: {
                                    value: tier.penalty_percent,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        tier,
                                        "penalty_percent",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression: "tier.penalty_percent",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "vx-col sm:w-1/12 w-full pb-2" },
                      [
                        _c("feather-icon", {
                          staticClass:
                            "h-5 w-5 stroke-current text-danger cursor-pointer",
                          attrs: { icon: "Trash2Icon" },
                          on: {
                            click: function ($event) {
                              return _vm.removeTier(i)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]
              )
            }),
          ],
          2
        ),
        _c("vx-card", { staticClass: "mb-4" }, [
          _c("h4", { staticClass: "mb-4" }, [
            _vm._v(_vm._s(_vm.$t("cancellation.franchise_title"))),
          ]),
          _c(
            "div",
            {
              staticClass:
                "flex justify-between items-center border-bottom pb-3 mb-3",
            },
            [
              _c("div", [
                _c("div", [
                  _vm._v(_vm._s(_vm.$t("cancellation.franchise_label"))),
                ]),
                _c("small", { staticClass: "text-muted" }, [
                  _vm._v(_vm._s(_vm.$t("cancellation.franchise_hint"))),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "flex items-center gap-4" },
                [
                  _c("b-form-input", {
                    staticClass: "text-center mr-2",
                    staticStyle: { width: "72px" },
                    attrs: { type: "number", min: "0" },
                    model: {
                      value: _vm.version.free_cancellations_per_month,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.version,
                          "free_cancellations_per_month",
                          _vm._n($$v)
                        )
                      },
                      expression: "version.free_cancellations_per_month",
                    },
                  }),
                  _c("b-form-checkbox", {
                    attrs: { switch: "" },
                    model: {
                      value: _vm.version.franchise_enabled,
                      callback: function ($$v) {
                        _vm.$set(_vm.version, "franchise_enabled", $$v)
                      },
                      expression: "version.franchise_enabled",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _c(
            "div",
            {
              staticClass:
                "flex justify-between items-center border-bottom pb-3 mb-3",
            },
            [
              _c("div", [
                _c("div", [
                  _vm._v(_vm._s(_vm.$t("cancellation.allow_reschedule"))),
                ]),
                _c("small", { staticClass: "text-muted" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("cancellation.reschedule_hint", {
                          hours: _vm.version.reschedule_min_hours,
                        })
                      ) +
                      " "
                  ),
                ]),
              ]),
              _c("b-form-checkbox", {
                attrs: { switch: "" },
                model: {
                  value: _vm.version.allow_reschedule,
                  callback: function ($$v) {
                    _vm.$set(_vm.version, "allow_reschedule", $$v)
                  },
                  expression: "version.allow_reschedule",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flex justify-between items-center" },
            [
              _c("div", [
                _c("div", [
                  _vm._v(_vm._s(_vm.$t("cancellation.credit_no_slot"))),
                ]),
                _c("small", { staticClass: "text-muted" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("cancellation.credit_validity", {
                          months: _vm.version.credit_validity_months,
                        })
                      ) +
                      " "
                  ),
                ]),
              ]),
              _c("b-form-checkbox", {
                attrs: { switch: "" },
                model: {
                  value: _vm.version.credit_when_no_slot,
                  callback: function ($$v) {
                    _vm.$set(_vm.version, "credit_when_no_slot", $$v)
                  },
                  expression: "version.credit_when_no_slot",
                },
              }),
            ],
            1
          ),
        ]),
        _c(
          "vx-card",
          { staticClass: "mb-4" },
          [
            _c("h4", { staticClass: "mb-1" }, [
              _vm._v(_vm._s(_vm.$t("cancellation.exceptions_title"))),
            ]),
            _c("small", { staticClass: "text-muted d-block mb-3" }, [
              _vm._v(_vm._s(_vm.$t("cancellation.exceptions_hint"))),
            ]),
            _c(
              "b-form-checkbox",
              {
                staticClass: "mb-1",
                model: {
                  value: _vm.exceptions.medical_certificate,
                  callback: function ($$v) {
                    _vm.$set(_vm.exceptions, "medical_certificate", $$v)
                  },
                  expression: "exceptions.medical_certificate",
                },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("cancellation.exception_.medical_certificate")
                    ) +
                    " "
                ),
              ]
            ),
            _c(
              "div",
              { staticClass: "flex items-center mb-1" },
              [
                _c(
                  "b-form-checkbox",
                  {
                    staticClass: "mr-2",
                    model: {
                      value: _vm.exceptions.high_value,
                      callback: function ($$v) {
                        _vm.$set(_vm.exceptions, "high_value", $$v)
                      },
                      expression: "exceptions.high_value",
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("cancellation.exception_.high_value")) +
                        " "
                    ),
                  ]
                ),
                _c(
                  "b-input-group",
                  {
                    staticStyle: { width: "140px" },
                    attrs: { prepend: "R$", size: "sm" },
                  },
                  [
                    _c("b-form-input", {
                      attrs: {
                        disabled: !_vm.exceptions.high_value,
                        type: "number",
                        min: "0",
                        size: "sm",
                      },
                      model: {
                        value: _vm.exceptions.high_value_threshold,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.exceptions,
                            "high_value_threshold",
                            _vm._n($$v)
                          )
                        },
                        expression: "exceptions.high_value_threshold",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "b-form-checkbox",
              {
                staticClass: "mb-1",
                model: {
                  value: _vm.exceptions.frequent_cancellations,
                  callback: function ($$v) {
                    _vm.$set(_vm.exceptions, "frequent_cancellations", $$v)
                  },
                  expression: "exceptions.frequent_cancellations",
                },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("cancellation.exception_.frequent_cancellations")
                    ) +
                    " "
                ),
              ]
            ),
            _c(
              "b-form-checkbox",
              {
                model: {
                  value: _vm.exceptions.regret_window,
                  callback: function ($$v) {
                    _vm.$set(_vm.exceptions, "regret_window", $$v)
                  },
                  expression: "exceptions.regret_window",
                },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("cancellation.exception_.regret_window")) +
                    " "
                ),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "vx-col lg:w-2/5 w-full" },
      [
        _c(
          "vx-card",
          { staticClass: "mb-4" },
          [
            _c("h4", { staticClass: "mb-3" }, [
              _vm._v(_vm._s(_vm.$t("cancellation.student_preview"))),
            ]),
            _c("div", { staticClass: "border rounded p-1 mb-3" }, [
              _c("small", { staticClass: "font-medium d-block mb-1" }, [
                _vm._v(_vm._s(_vm.$t("cancellation.student_preview_hint"))),
              ]),
              _c("small", { staticClass: "text-muted" }, [
                _vm._v(_vm._s(_vm.studentPreview)),
              ]),
            ]),
            _c(
              "b-alert",
              {
                staticClass: "p-1 mb-3",
                attrs: { show: "", variant: "warning" },
              },
              [
                _c(
                  "div",
                  { staticClass: "flex items-start" },
                  [
                    _c("feather-icon", {
                      staticClass: "mr-1 flex-shrink-0",
                      attrs: { icon: "GitBranchIcon" },
                    }),
                    _c("small", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("cancellation.publish_warning", {
                            version: "v" + _vm.version.version,
                          })
                        )
                      ),
                    ]),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "div",
              { staticClass: "flex gap-4" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "mr-2",
                    attrs: { variant: "primary", disabled: !_vm.model.name },
                    on: { click: _vm.publish },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("cancellation.publish")) +
                        " v" +
                        _vm._s(_vm.version.version) +
                        " "
                    ),
                  ]
                ),
                _c(
                  "b-button",
                  {
                    attrs: {
                      variant: "outline-secondary",
                      disabled: !_vm.model.name,
                    },
                    on: { click: _vm.saveDraft },
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.$t("cancellation.save_draft")) + " "
                    ),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "vx-card",
          [
            _c("h4", { staticClass: "mb-3" }, [
              _vm._v(_vm._s(_vm.$t("cancellation.simulator"))),
            ]),
            _c(
              "b-form-group",
              { attrs: { label: _vm.$t("cancellation.simulator_at") } },
              [
                _c("b-form-select", {
                  attrs: { options: _vm.hourOptions },
                  on: { change: _vm.simulate },
                  model: {
                    value: _vm.simulator.hours,
                    callback: function ($$v) {
                      _vm.$set(_vm.simulator, "hours", $$v)
                    },
                    expression: "simulator.hours",
                  },
                }),
              ],
              1
            ),
            _c(
              "b-form-group",
              { attrs: { label: "Valor da reserva" } },
              [
                _c(
                  "b-input-group",
                  { attrs: { prepend: "R$" } },
                  [
                    _c("b-form-input", {
                      attrs: { type: "number", min: "0" },
                      on: { change: _vm.simulate },
                      model: {
                        value: _vm.simulator.amount,
                        callback: function ($$v) {
                          _vm.$set(_vm.simulator, "amount", _vm._n($$v))
                        },
                        expression: "simulator.amount",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.simulator.result
              ? _c("div", { staticClass: "border-top pt-3" }, [
                  _c("div", { staticClass: "flex justify-between mb-1" }, [
                    _c("small", { staticClass: "text-muted" }, [
                      _vm._v(_vm._s(_vm.$t("cancellation.simulator_tier"))),
                    ]),
                    _c("small", [
                      _vm._v(_vm._s(_vm.simulator.result.tier_label || "—")),
                    ]),
                  ]),
                  _c("div", { staticClass: "flex justify-between mb-1" }, [
                    _c("small", { staticClass: "text-muted" }, [
                      _vm._v(_vm._s(_vm.$t("cancellation.simulator_receives"))),
                    ]),
                    _c("small", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.formatValue(_vm.simulator.result.remedy_amount)
                          ) +
                          " "
                      ),
                      _vm.simulator.result.remedy === "CR"
                        ? _c("span", [_vm._v("em crédito")])
                        : _vm.simulator.result.remedy === "CH"
                        ? _c("span", [_vm._v("· cliente escolhe")])
                        : _vm._e(),
                    ]),
                  ]),
                  _c("div", { staticClass: "flex justify-between mb-1" }, [
                    _c("small", { staticClass: "text-muted" }, [
                      _vm._v(_vm._s(_vm.$t("cancellation.simulator_retains"))),
                    ]),
                    _c("small", [
                      _vm._v(
                        _vm._s(
                          _vm.formatValue(_vm.simulator.result.retained_amount)
                        )
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "flex justify-between" }, [
                    _c("small", { staticClass: "text-muted" }, [
                      _vm._v(
                        _vm._s(_vm.$t("cancellation.simulator_resolution"))
                      ),
                    ]),
                    _c(
                      "small",
                      {
                        staticClass: "font-medium",
                        class:
                          _vm.simulator.result.resolution === "AU"
                            ? "text-success"
                            : "text-warning",
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "cancellation.resolution_." +
                                  _vm.simulator.result.resolution
                              )
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ]),
                ])
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }